<div class="wrapper--spacing-horizontal print-content">
  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="header-image"></div>
    <h1 class="align-center">{{ 'interval-type-Week' | translate }} {{ weekNumber }}</h1>
    <div class="row">
      <div class="column_l">
        <!------------------------------------------------------- GENERAL -->
        <div class="table">
          <div class="header">
            <span>{{ 'report-headers.general' | translate }}</span>
          </div>
          <div class="column_body">
            <ul class="list-unstyled">
              <li>
                <label>{{ 'report-columns.customer' | translate }}</label>
                <span class="value">{{ customer?.name }}</span>
              </li>
              <li>
                <label>{{ 'report-columns.location' | translate }}</label>
                <span class="value">{{ location?.name }}</span>
              </li>
              <li>
                <label>{{ 'report-columns.cycle-nr' | translate }}</label>
                <span class="value">{{ cycle?.cycleNumber }}</span>
              </li>
              <li>
                <label>{{ 'report-columns.barns' | translate }}</label>
                <span class="value">{{ getBarnNames() }}</span>
              </li>
              <li>
                <label>{{ 'report-columns.breed' | translate }}</label>
                <span class="value">{{ getBreeds() }}</span>
              </li>
              <li>
                <label>{{ 'report-columns.concept' | translate }}</label>
                <span class="value">{{ cycle?.concept?.name }}</span>
              </li>
              <li>
                <label>{{ 'report-columns.start-date' | translate }}</label>
                <span class="value">{{ cycle?.cycleDate | agrDate: 'shortDate' }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="spacer">&nbsp;</div>

        <div class="table">
          <div class="header">
            {{ 'report-headers.departures' | translate }}
          </div>
          <div class="column_body">
            <table class="table-m">
              <thead>
                <tr>
                  <th>{{ 'report-columns.barns' | translate }}</th>
                  <th *ngIf="isVisible('IndoorTemperature')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.IndoorTemperature' | translate }}
                  </th>
                  <th *ngIf="isVisible('IndoorHumidity')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.IndoorHumidity' | translate }}
                  </th>
                  <th *ngIf="isVisible('MortalityPercentageCumulative')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.MortalityPercentage' | translate }}
                  </th>
                  <th *ngIf="isVisible('FeedIntakePerChickCumulative')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.FeedIntakePerChick' | translate }}
                  </th>
                  <th *ngIf="isVisible('WaterIntakePerChickCumulative')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.WaterIntakePerChick' | translate }}
                  </th>
                  <th *ngIf="isVisible('WeightGainPerChickCumulative')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.WeightGainPerChick' | translate }}
                  </th>
                  <th *ngIf="isVisible('WaterToFeedRatioCumulative')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.WaterToFeedRatio' | translate }}
                  </th>
                  <th *ngIf="isVisible('FeedConversionRateCumulative')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.FeedConversionRate' | translate }}
                  </th>
                  <th *ngIf="isVisible('BodyWeight')" [attr.colspan]="2">
                    {{ 'within-cycle-performance.kpis.BodyWeight' | translate }}
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <ng-container *ngIf="isVisible('IndoorTemperature')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('IndoorHumidity')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('MortalityPercentageCumulative')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('FeedIntakePerChickCumulative')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('WaterIntakePerChickCumulative')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('WeightGainPerChickCumulative')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('WaterToFeedRatioCumulative')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('FeedConversionRateCumulative')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                  <ng-container *ngIf="isVisible('BodyWeight')">
                    <th>Ref</th>
                    <th>Actual</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let barn of barns">
                  <td width="80px">{{ barn.name }}</td>
                  <ng-container
                    *ngIf="
                      isVisible('IndoorTemperature') &&
                      getWeeklyReportValue(barn, 'IndoorTemperature') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('IndoorHumidity') &&
                      getWeeklyReportValue(barn, 'IndoorHumidity') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('MortalityPercentageCumulative') &&
                      getWeeklyReportValue(barn, 'MortalityPercentageCumulative') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('FeedIntakePerChickCumulative') &&
                      getWeeklyReportValue(barn, 'FeedIntakePerChickCumulative') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('WaterIntakePerChickCumulative') &&
                      getWeeklyReportValue(barn, 'WaterIntakePerChickCumulative') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('WeightGainPerChickCumulative') &&
                      getWeeklyReportValue(barn, 'WeightGainPerChickCumulative') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('WaterToFeedRatioCumulative') &&
                      getWeeklyReportValue(barn, 'WaterToFeedRatioCumulative') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('FeedConversionRateCumulative') &&
                      getWeeklyReportValue(barn, 'FeedConversionRateCumulative') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      isVisible('BodyWeight') && getWeeklyReportValue(barn, 'BodyWeight') as object
                    "
                  >
                    <td>{{ object.referenceValueSheetValue }}</td>
                    <td [ngClass]="{ warn: hasHighLight(object) }">
                      {{ object.actualValue }}
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
